import commonEn from './common/en'
import commonEs from './common/es'
import commonJa from './common/ja'
import commonTh from './common/th'
import commonVi from './common/vi'
import commonZhCn from './common/zh-CN'
import commonZhTw from './common/zh-TW'
import commonKo from './common/ko'
import commonFr from './common/fr'
import commonDe from './common/de'
import commonId from './common/id'
import validationEn from './validation/en'
import validationEs from './validation/es'
import validationJa from './validation/ja'
import validationTh from './validation/th'
import validationVi from './validation/vi'
import validationZhCn from './validation/zh-CN'
import validationZhTw from './validation/zh-TW'
import validationKo from './validation/ko'
import validationFr from './validation/fr'
import validationDe from './validation/de'
import validationId from './validation/id'
import dashboardEn from './dashboard/en'
import dashboardEs from './dashboard/es'
import dashboardJa from './dashboard/ja'
import dashboardTh from './dashboard/th'
import dashboardVi from './dashboard/vi'
import dashboardZhCn from './dashboard/zh-CN'
import dashboardZhTw from './dashboard/zh-TW'
import dashboardKo from './dashboard/ko'
import dashboardFr from './dashboard/fr'
import dashboardDe from './dashboard/de'
import dashboardId from './dashboard/id'
import evaluationDashboardEn from './evaluation/dashboard/en'
import evaluationDashboardEs from './evaluation/dashboard/es'
import evaluationDashboardJa from './evaluation/dashboard/ja'
import evaluationDashboardTh from './evaluation/dashboard/th'
import evaluationDashboardVi from './evaluation/dashboard/vi'
import evaluationDashboardZhCn from './evaluation/dashboard/zh-CN'
import evaluationDashboardZhTw from './evaluation/dashboard/zh-TW'
import evaluationDashboardKo from './evaluation/dashboard/ko'
import evaluationDashboardFr from './evaluation/dashboard/fr'
import evaluationDashboardDe from './evaluation/dashboard/de'
import evaluationDashboardId from './evaluation/dashboard/id'
import evaluationListEn from './evaluation/list/en'
import evaluationListEs from './evaluation/list/es'
import evaluationListJa from './evaluation/list/ja'
import evaluationListTh from './evaluation/list/th'
import evaluationListVi from './evaluation/list/vi'
import evaluationListZhCn from './evaluation/list/zh-CN'
import evaluationListZhTw from './evaluation/list/zh-TW'
import evaluationListKo from './evaluation/list/ko'
import evaluationListFr from './evaluation/list/fr'
import evaluationListDe from './evaluation/list/de'
import evaluationListId from './evaluation/list/id'
import scorecardEs from './scorecard/es'
import scorecardEn from './scorecard/en'
import scorecardJa from './scorecard/ja'
import scorecardTh from './scorecard/th'
import scorecardVi from './scorecard/vi'
import scorecardZhCn from './scorecard/zh-CN'
import scorecardZhTw from './scorecard/zh-TW'
import scorecardKo from './scorecard/ko'
import scorecardFr from './scorecard/fr'
import scorecardDe from './scorecard/de'
import scorecardId from './scorecard/id'
import improvementplansEn from './improvementplans/en'
import improvementplansEs from './improvementplans/es'
import improvementplansJa from './improvementplans/ja'
import improvementplansTh from './improvementplans/th'
import improvementplansVi from './improvementplans/vi'
import improvementplansZhCn from './improvementplans/zh-CN'
import improvementplansZhTw from './improvementplans/zh-TW'
import improvementplansKo from './improvementplans/ko'
import improvementplansFr from './improvementplans/fr'
import improvementplansDe from './improvementplans/de'
import improvementplansId from './improvementplans/id'
import improvementplansDetailEn from './improvementplans/detail/en'
import improvementplansDetailEs from './improvementplans/detail/es'
import improvementplansDetailJa from './improvementplans/detail/ja'
import improvementplansDetailTh from './improvementplans/detail/th'
import improvementplansDetailVi from './improvementplans/detail/vi'
import improvementplansDetailZhCn from './improvementplans/detail/zh-CN'
import improvementplansDetailZhTw from './improvementplans/detail/zh-TW'
import improvementplansDetailKo from './improvementplans/detail/ko'
import improvementplansDetailFr from './improvementplans/detail/fr'
import improvementplansDetailDe from './improvementplans/detail/de'
import improvementplansDetailId from './improvementplans/detail/id'
import settingsEn from './settings/en'
import settingsEs from './settings/es'
import settingsJa from './settings/ja'
import settingsTh from './settings/th'
import settingsVi from './settings/vi'
import settingsZhCn from './settings/zh-CN'
import settingsZhTw from './settings/zh-TW'
import settingsKo from './settings/ko'
import settingsFr from './settings/fr'
import settingsDe from './settings/de'
import settingsId from './settings/id'
import uploadcommonEs from './upload/common/es'
import uploadcommonEn from './upload/common/en'
import uploadcommonJa from './upload/common/ja'
import uploadcommonTh from './upload/common/th'
import uploadcommonVi from './upload/common/vi'
import uploadcommonZhCn from './upload/common/zh-CN'
import uploadcommonZhTw from './upload/common/zh-TW'
import uploadcommonKo from './upload/common/ko'
import uploadcommonFr from './upload/common/fr'
import uploadcommonDe from './upload/common/de'
import uploadcommonId from './upload/common/id'
import loginEs from './login/es'
import loginEn from './login/en'
import loginJa from './login/ja'
import loginTh from './login/th'
import loginVi from './login/vi'
import loginZhCn from './login/zh-CN'
import loginZhTw from './login/zh-TW'
import loginKo from './login/ko'
import loginFr from './login/fr'
import loginDe from './login/de'
import loginId from './login/id'
import loginMfaEn from './login-mfa/en'
import loginMfaEs from './login-mfa/es'
import loginMfaJa from './login-mfa/ja'
import loginMfaTh from './login-mfa/th'
import loginMfaVi from './login-mfa/vi'
import loginMfaZhCn from './login-mfa/zh-CN'
import loginMfaZhTw from './login-mfa/zh-TW'
import loginMfaKo from './login-mfa/ko'
import loginMfaFr from './login-mfa/fr'
import loginMfaDe from './login-mfa/de'
import loginMfaId from './login-mfa/id'
import forgotPasswordEn from './forgot-password/en'
import forgotPasswordEs from './forgot-password/es'
import forgotPasswordJa from './forgot-password/ja'
import forgotPasswordTh from './forgot-password/th'
import forgotPasswordVi from './forgot-password/vi'
import forgotPasswordZhCn from './forgot-password/zh-CN'
import forgotPasswordZhTw from './forgot-password/zh-TW'
import forgotPasswordKo from './forgot-password/ko'
import forgotPasswordFr from './forgot-password/fr'
import forgotPasswordDe from './forgot-password/de'
import forgotPasswordId from './forgot-password/id'
import forgotPasswordConfirmEn from './forgot-password-confirm/en'
import forgotPasswordConfirmEs from './forgot-password-confirm/es'
import forgotPasswordConfirmJa from './forgot-password-confirm/ja'
import forgotPasswordConfirmTh from './forgot-password-confirm/th'
import forgotPasswordConfirmVi from './forgot-password-confirm/vi'
import forgotPasswordConfirmZhCn from './forgot-password-confirm/zh-CN'
import forgotPasswordConfirmZhTw from './forgot-password-confirm/zh-TW'
import forgotPasswordConfirmKo from './forgot-password-confirm/ko'
import forgotPasswordConfirmFr from './forgot-password-confirm/fr'
import forgotPasswordConfirmDe from './forgot-password-confirm/de'
import forgotPasswordConfirmId from './forgot-password-confirm/id'
import forgotPasswordSubmitEn from './forgot-password-submit/en'
import forgotPasswordSubmitEs from './forgot-password-submit/es'
import forgotPasswordSubmitJa from './forgot-password-submit/ja'
import forgotPasswordSubmitTh from './forgot-password-submit/th'
import forgotPasswordSubmitVi from './forgot-password-submit/vi'
import forgotPasswordSubmitZhCn from './forgot-password-submit/zh-CN'
import forgotPasswordSubmitZhTw from './forgot-password-submit/zh-TW'
import forgotPasswordSubmitKo from './forgot-password-submit/ko'
import forgotPasswordSubmitFr from './forgot-password-submit/fr'
import forgotPasswordSubmitDe from './forgot-password-submit/de'
import forgotPasswordSubmitId from './forgot-password-submit/id'
import contactEs from './contact/es'
import contactEn from './contact/en'
import contactJa from './contact/ja'
import contactTh from './contact/th'
import contactVi from './contact/vi'
import contactZhCn from './contact/zh-CN'
import contactZhTw from './contact/zh-TW'
import contactKo from './contact/ko'
import contactFr from './contact/fr'
import contactDe from './contact/de'
import contactId from './contact/id'
import registrationJa from './registration/ja'
import registrationEn from './registration/en'
import registrationEs from './registration/es'
import registrationTh from './registration/th'
import registrationVi from './registration/vi'
import registrationZhCn from './registration/zh-CN'
import registrationZhTw from './registration/zh-TW'
import registrationKo from './registration/ko'
import registrationFr from './registration/fr'
import registrationDe from './registration/de'
import registrationId from './registration/id'
import emailComfirmEn from './email-confirm/en'
import emailComfirmEs from './email-confirm/es'
import emailComfirmJa from './email-confirm/ja'
import emailComfirmTh from './email-confirm/th'
import emailComfirmVi from './email-confirm/vi'
import emailComfirmZhCn from './email-confirm/zh-CN'
import emailComfirmZhTw from './email-confirm/zh-TW'
import emailComfirmKo from './email-confirm/ko'
import emailComfirmFr from './email-confirm/fr'
import emailComfirmDe from './email-confirm/de'
import emailComfirmId from './email-confirm/id'
import errorEn from './errors/en'
import errorEs from './errors/es'
import errorJa from './errors/ja'
import errorTh from './errors/th'
import errorVi from './errors/vi'
import errorZhCn from './errors/zh-CN'
import errorZhTw from './errors/zh-TW'
import errorKo from './errors/ko'
import errorFr from './errors/fr'
import errorDe from './errors/de'
import errorId from './errors/id'
import esgDataEn from './esg-data/en'
import esgDataEs from './esg-data/es'
import esgDataJa from './esg-data/ja'
import esgDataTh from './esg-data/th'
import esgDataVi from './esg-data/vi'
import esgDataZhCn from './esg-data/zh-CN'
import esgDataZhTw from './esg-data/zh-TW'
import esgDataKo from './esg-data/ko'
import esgDataFr from './esg-data/fr'
import esgDataDe from './esg-data/de'
import esgDataId from './esg-data/id'
import functionEn from './function/en'
import functionEs from './function/es'
import functionJa from './function/ja'
import functionTh from './function/th'
import functionVi from './function/vi'
import functionZhCn from './function/zh-CN'
import functionZhTw from './function/zh-TW'
import functionKo from './function/ko'
import functionFr from './function/fr'
import functionDe from './function/de'
import functionId from './function/id'
import buyerCreateQuestionEn from './buyer_create_question/en'
import buyerCreateQuestionEs from './buyer_create_question/es'
import buyerCreateQuestionJa from './buyer_create_question/ja'
import buyerCreateQuestionTh from './buyer_create_question/th'
import buyerCreateQuestionVi from './buyer_create_question/vi'
import buyerCreateQuestionZhCn from './buyer_create_question/zh-CN'
import buyerCreateQuestionZhTw from './buyer_create_question/zh-TW'
import buyerCreateQuestionKo from './buyer_create_question/ko'
import buyerCreateQuestionFr from './buyer_create_question/fr'
import buyerCreateQuestionDe from './buyer_create_question/de'
import buyerCreateQuestionId from './buyer_create_question/id'

export const messages = {
  en: {
    ...commonEn,
    ...validationEn,
    ...dashboardEn,
    ...evaluationDashboardEn,
    ...evaluationListEn,
    ...scorecardEn,
    ...improvementplansEn,
    ...improvementplansDetailEn,
    ...settingsEn,
    ...uploadcommonEn,
    ...loginEn,
    ...loginMfaEn,
    ...forgotPasswordEn,
    ...forgotPasswordConfirmEn,
    ...forgotPasswordSubmitEn,
    ...contactEn,
    ...registrationEn,
    ...emailComfirmEn,
    ...errorEn,
    ...esgDataEn,
    ...functionEn,
    ...buyerCreateQuestionEn,
  },
  ja: {
    ...commonJa,
    ...validationJa,
    ...dashboardJa,
    ...evaluationDashboardJa,
    ...evaluationListJa,
    ...scorecardJa,
    ...improvementplansJa,
    ...improvementplansDetailJa,
    ...settingsJa,
    ...uploadcommonJa,
    ...loginJa,
    ...loginMfaJa,
    ...forgotPasswordJa,
    ...forgotPasswordConfirmJa,
    ...forgotPasswordSubmitJa,
    ...contactJa,
    ...registrationJa,
    ...emailComfirmJa,
    ...errorJa,
    ...esgDataJa,
    ...functionJa,
    ...buyerCreateQuestionJa,
  },
  es: {
    ...commonEs,
    ...validationEs,
    ...evaluationListEs,
    ...evaluationDashboardEs,
    ...improvementplansEs,
    ...improvementplansDetailEs,
    ...settingsEs,
    ...uploadcommonEs,
    ...forgotPasswordEs,
    ...forgotPasswordConfirmEs,
    ...forgotPasswordSubmitEs,
    ...contactEs,
    ...loginEs,
    ...loginMfaEs,
    ...dashboardEs,
    ...scorecardEs,
    ...registrationEs,
    ...emailComfirmEs,
    ...errorEs,
    ...esgDataEs,
    ...functionEs,
    ...buyerCreateQuestionEs,
  },
  th: {
    ...commonTh,
    ...validationTh,
    ...evaluationListTh,
    ...evaluationDashboardTh,
    ...improvementplansTh,
    ...improvementplansDetailTh,
    ...settingsTh,
    ...uploadcommonTh,
    ...forgotPasswordTh,
    ...forgotPasswordConfirmTh,
    ...forgotPasswordSubmitTh,
    ...contactTh,
    ...loginTh,
    ...loginMfaTh,
    ...dashboardTh,
    ...scorecardTh,
    ...registrationTh,
    ...emailComfirmTh,
    ...errorTh,
    ...esgDataTh,
    ...functionTh,
    ...buyerCreateQuestionTh,
  },
  vi: {
    ...commonVi,
    ...validationVi,
    ...evaluationListVi,
    ...evaluationDashboardVi,
    ...improvementplansVi,
    ...improvementplansDetailVi,
    ...settingsVi,
    ...uploadcommonVi,
    ...forgotPasswordVi,
    ...forgotPasswordConfirmVi,
    ...forgotPasswordSubmitVi,
    ...contactVi,
    ...loginVi,
    ...loginMfaVi,
    ...dashboardVi,
    ...scorecardVi,
    ...registrationVi,
    ...emailComfirmVi,
    ...errorVi,
    ...esgDataVi,
    ...functionVi,
    ...buyerCreateQuestionVi,
  },
  'zh-CN': {
    ...commonZhCn,
    ...validationZhCn,
    ...evaluationListZhCn,
    ...evaluationDashboardZhCn,
    ...improvementplansZhCn,
    ...improvementplansDetailZhCn,
    ...settingsZhCn,
    ...uploadcommonZhCn,
    ...forgotPasswordZhCn,
    ...forgotPasswordConfirmZhCn,
    ...forgotPasswordSubmitZhCn,
    ...contactZhCn,
    ...loginZhCn,
    ...loginMfaZhCn,
    ...dashboardZhCn,
    ...scorecardZhCn,
    ...registrationZhCn,
    ...emailComfirmZhCn,
    ...errorZhCn,
    ...esgDataZhCn,
    ...functionZhCn,
    ...buyerCreateQuestionZhCn,
  },
  'zh-TW': {
    ...commonZhTw,
    ...validationZhTw,
    ...evaluationListZhTw,
    ...evaluationDashboardZhTw,
    ...improvementplansZhTw,
    ...improvementplansDetailZhTw,
    ...settingsZhTw,
    ...uploadcommonZhTw,
    ...forgotPasswordZhTw,
    ...forgotPasswordConfirmZhTw,
    ...forgotPasswordSubmitZhTw,
    ...contactZhTw,
    ...loginZhTw,
    ...loginMfaZhTw,
    ...dashboardZhTw,
    ...scorecardZhTw,
    ...registrationZhTw,
    ...emailComfirmZhTw,
    ...errorZhTw,
    ...esgDataZhTw,
    ...functionZhTw,
    ...buyerCreateQuestionZhTw,
  },
  ko: {
    ...commonKo,
    ...dashboardKo,
    ...emailComfirmKo,
    ...errorKo,
    ...esgDataKo,
    ...evaluationListKo,
    ...evaluationDashboardKo,
    ...forgotPasswordKo,
    ...forgotPasswordConfirmKo,
    ...forgotPasswordSubmitKo,
    ...improvementplansKo,
    ...improvementplansDetailKo,
    ...contactKo,
    ...loginKo,
    ...loginMfaKo,
    ...scorecardKo,
    ...settingsKo,
    ...uploadcommonKo,
    ...validationKo,
    ...registrationKo,
    ...functionKo,
    ...buyerCreateQuestionKo,
  },
  fr: {
    ...commonFr,
    ...dashboardFr,
    ...emailComfirmFr,
    ...errorFr,
    ...esgDataFr,
    ...evaluationListFr,
    ...evaluationDashboardFr,
    ...forgotPasswordFr,
    ...forgotPasswordConfirmFr,
    ...forgotPasswordSubmitFr,
    ...improvementplansFr,
    ...improvementplansDetailFr,
    ...contactFr,
    ...loginFr,
    ...loginMfaFr,
    ...scorecardFr,
    ...settingsFr,
    ...uploadcommonFr,
    ...validationFr,
    ...registrationFr,
    ...functionFr,
    ...buyerCreateQuestionFr,
  },
  de: {
    ...commonDe,
    ...dashboardDe,
    ...emailComfirmDe,
    ...errorDe,
    ...esgDataDe,
    ...evaluationListDe,
    ...evaluationDashboardDe,
    ...forgotPasswordDe,
    ...forgotPasswordConfirmDe,
    ...forgotPasswordSubmitDe,
    ...improvementplansDe,
    ...improvementplansDetailDe,
    ...contactDe,
    ...loginDe,
    ...loginMfaDe,
    ...scorecardDe,
    ...settingsDe,
    ...uploadcommonDe,
    ...validationDe,
    ...registrationDe,
    ...functionDe,
    ...buyerCreateQuestionDe,
  },
  id: {
    ...commonId,
    ...dashboardId,
    ...emailComfirmId,
    ...errorId,
    ...esgDataId,
    ...evaluationListId,
    ...evaluationDashboardId,
    ...forgotPasswordId,
    ...forgotPasswordConfirmId,
    ...forgotPasswordSubmitId,
    ...improvementplansId,
    ...improvementplansDetailId,
    ...contactId,
    ...loginId,
    ...loginMfaId,
    ...scorecardId,
    ...settingsId,
    ...uploadcommonId,
    ...validationId,
    ...registrationId,
    ...functionId,
    ...buyerCreateQuestionId,
  }
}
